<div class="c-portlet datatable-v3 o-block u-width-100p _u-width-100p u-shadow-mini u-bg-primary c-portlet_box_specs" style="position:relative;">
  <div class="">
    <div class="carousel lift-carousel">
      <ngu-carousel #carousel [inputs]="carouselOne" [dataSource]="carouselData">
        <ngu-tile NguCarouselItem *nguCarouselDef="let tableData;">
          <div class="datatable-title o-stack o-stack--center o-stack--splitted u-px-small u-py-mini c-portlet-gap">
            <h5>{{tableData.campaign_name}}</h5>
          </div>
          <div class="analytics-portlet-content analytics-datatable-scrollable" id="datatable-carousel-container">
            <ngx-datatable style="height: 100%;" class="datatable" [columns]="tableData.columns" [rows]="tableData.data" [sortType]="'single'" [cssClasses]="cssClasses"
              [columnMode]="'force'" [headerHeight]="64" [footerHeight]="0" [rowHeight]="50" [reorderable]="reorderable"  [scrollbarV]="true">
            </ngx-datatable>
          </div>
        </ngu-tile>
        <span NguCarouselPrev class="leftRs" (click)="prevArrow()" *ngIf="carouselData.length>1">
          <i class="fa fa-angle-left" aria-hidden="true"></i>
        </span>
        <span NguCarouselNext class="rightRs" (click)="nextArrow()" *ngIf="carouselData.length>1">
          <i class="fa fa-angle-right" aria-hidden="true"></i>
        </span>
      </ngu-carousel>
    </div>
  </div>
